import classNames from 'classnames';
import Link from 'next/link';
import type { FC, PropsWithChildren } from 'react';

import MindPalLogoIcon from '@/assets/logo-black.svg';
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from '@/components/ui/sidebar';
import { useRedirectAuthUsers } from '@/hooks/useRedirectAuthUsers';

import AppSidebar from './AppSidebar';

type Props = {
  position?: 'fixed' | 'overflow';
};

const AppSidebarLayout: FC<PropsWithChildren<Props>> = ({
  children,
  position = 'overflow',
}) => {
  useRedirectAuthUsers();

  return (
    <SidebarProvider>
      <style jsx global>
        {`
          body {
            background: #f6f6f6;
          }
        `}
      </style>
      <AppSidebar />
      <SidebarInset
        id="main-scroll-container"
        className={classNames('min-w-0 bg-transparent', {
          'h-[100dvh] overflow-y-auto overflow-x-hidden overscroll-contain':
            position === 'overflow',
        })}
      >
        <div className="sticky top-0 z-20 grid h-14 shrink-0 grid-cols-3 items-center gap-3 border-b border-jb-neutral-600 bg-jb-neutral-100/80 px-4 md:hidden">
          <SidebarTrigger />
          <Link
            href="/jobs"
            className="flex flex-col items-center justify-center text-jb-primary-500"
          >
            <MindPalLogoIcon className="h-5 w-8" />
          </Link>
          <div />
        </div>
        {children}
      </SidebarInset>
      {/* <HelpUsImprove /> */}
    </SidebarProvider>
  );
};

export default AppSidebarLayout;
